import { Button, Grid, TextField } from '@material-ui/core';
import { FormikProps } from 'formik';
import React, { FC, useMemo, useState } from 'react';
import { DescriptionHtmlDialog } from 'src/components/dialogs/DescriptionHtmlDialog';
import { EmailerDetails } from 'src/redux/slices/emailer';
import { decodeBase64Html } from 'src/utils';

interface Props {
  isCreatePage?: boolean;
  formik: FormikProps<EmailerDetails>;
  id?: number;
  isLoading?: boolean;
}

export const EmailerForm: FC<Props> = ({
  isCreatePage = false,
  formik,
  id,
  isLoading
}) => {
  const [isOpenContentModal, setIsOpenContentModal] = useState<boolean>(false);

  const descriptionHtml = useMemo(
    () => decodeBase64Html(formik?.values?.content_html_url),
    [formik]
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          disabled={isLoading}
          label="Email Subject"
          name="title"
          variant="outlined"
          fullWidth
          value={formik?.values?.title ?? ''}
          onChange={formik.handleChange}
        />
      </Grid>

      {/* Emailer content is only availabe on details page */}
      {!isCreatePage ? (
        <Grid item xs={12}>
          <Button
            onClick={() => setIsOpenContentModal(!isOpenContentModal)}
            variant="outlined"
            color="primary"
            fullWidth
            style={{
              height: 53
            }}
          >
            Create/Edit Content
          </Button>
        </Grid>
      ) : null}
      {!isCreatePage ? (
        <DescriptionHtmlDialog
          title="Emailer Content"
          productId={id}
          description={descriptionHtml}
          isOpen={isOpenContentModal}
          handleClose={() => setIsOpenContentModal(false)}
          reloadProductDetails={() => console.log('reloadProductDetails')}
          variant="emailer"
        />
      ) : null}
    </Grid>
  );
};
